<template>
<div class="chapter">
<div class="inner_page">
<p class="pn">I</p>
<p class="pt" id="pt1">FUSION TORCH SHIP <span class="epub-i">AUSTRALIA</span></p>
<p class="pep">To follow knowledge like a sinking star,</p>
<p class="pep-bot">Beyond the utmost bound of human thought.</p>
<p class="pepc">—Alfred, Lord Tennyson<br/><span class="epub-i">Ulysses</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?36f5194e